module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/37.be7ecdb6.png";